import React, { useRef, useEffect,useState } from 'react'
import lottie from 'lottie-web';


function OtherCourses() {


  const html = useRef(null)
  const css = useRef(null)
  const kotlin = useRef(null)
  const c = useRef(null)
  const javascript = useRef(null)
  const python = useRef(null)
  const react = useRef(null)
  const java = useRef(null)


  useEffect(() => {
    const instance = lottie.loadAnimation({
      container: html.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: require('../Assets/json/html-5.json')
    })
    return () => instance.destroy();
  }, [])

  useEffect(() => {
    const instance = lottie.loadAnimation({
      container: css.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: require('../Assets/json/css3.json')
    })
    return () => instance.destroy();
  }, [])

  useEffect(() => {
    const instance = lottie.loadAnimation({
      container: kotlin.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: require('../Assets/json/kotlin.json')
    })
    return () => instance.destroy();
  }, [])

  useEffect(() => {
    const instance = lottie.loadAnimation({
      container: c.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: require('../Assets/json/c-programming-animation.json')
    })
    return () => instance.destroy();
  }, [])

  useEffect(() => {
    const instance = lottie.loadAnimation({
      container: javascript.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: require('../Assets/json/javascript-logo.json')
    })
    return () => instance.destroy();
  }, [])

  useEffect(() => {
    const instance = lottie.loadAnimation({
      container: python.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: require('../Assets/json/python-logo.json')
    })
    return () => instance.destroy();
  }, [])

  useEffect(() => {
    const instance = lottie.loadAnimation({
      container: react.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: require('../Assets/json/react-native.json')
    })
    return () => instance.destroy();
  }, [])

  useEffect(() => {
    const instance = lottie.loadAnimation({
      container: java.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: require('../Assets/json/java-logo.json')
    })
    return () => instance.destroy();
  }, [])

  const [GetData, setGetData] = useState( [
    {
      id: 1,
      Name: 'Html',
      description: 'ggjjfsdkdfsdkjsdkfjsdkfjdskj',
      AnimatedImg: <div ref={html} />
    },
    {
      id: 2,
      Name: 'Css',
      description: 'ggjjfsdkdfsdkjsdkfjsdkfjdskj',
      AnimatedImg: <div ref={css} />
    },
    {
      id: 3,
      Name: 'Kotlin',
      description: 'ggjjfsdkdfsdkjsdkfjsdkfjdskj',
      AnimatedImg: <div ref={kotlin} />
    },
    {
      id: 4,
      Name: 'Java',
      description: 'ggjjfsdkdfsdkjsdkfjsdkfjdskj',
      AnimatedImg: <div ref={java} />
    },
    {
      id: 5,
      Name: 'Javascript',
      description: 'ggjjfsdkdfsdkjsdkfjsdkfjdskj',
      AnimatedImg: <div ref={javascript} />
    },
    {
      id: 6,
      Name: 'Python',
      description: 'ggjjfsdkdfsdkjsdkfjsdkfjdskj',
      AnimatedImg: <div ref={python} />
    },
    {
      id: 7,
      Name: 'React Native',
      description: 'ggjjfsdkdfsdkjsdkfjsdkfjdskj',
      AnimatedImg: <div ref={react} />
    },
    {
      id: 8,
      Name: 'C, C++',
      description: 'ggjjfsdkdfsdkjsdkfjsdkfjdskj',
      AnimatedImg: <div ref={c} />
    },


  ]
)
  return (
    <div className='justify-center items-center grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 mx-auto gap-4 container min-h-full'  >
      {
        GetData.map((item, index) => {
          return (
            <div class="max-w-sm bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
              <a className=' justify-center flex bg-slate-50'>
                <div className="w-44 h-44" >{item.AnimatedImg}</div>
              </a>
              <div class="p-5" >
                <a href="#">
                  <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">{item.Name}</h5>
                </a>
                <p class="mb-3 font-normal text-gray-700 dark:text-gray-400">{item.description}</p>
                <div className='flex justify-end' >
                  <div data-te-toggle="modal"
                    data-te-target="#exampleModalFullscreen"
                    data-te-ripple-init
                    data-te-ripple-color="light"
                    
                    >
                    
                    <a href="#_" class="relative inline-flex items-center pl-5 pr-12 py-2 overflow-hidden text-lg font-medium text-indigo-600 border-2 border-indigo-600 rounded-full hover:text-white group hover:bg-gray-50">
                      <span class="absolute left-0 block w-full h-0 transition-all bg-indigo-600 opacity-100 group-hover:h-full top-1/2 group-hover:top-0 duration-400 ease"></span>
                      <span class="absolute right-0 flex items-center justify-start w-10 h-10 duration-300 transform translate-x-full group-hover:translate-x-0 ease">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
                      </span>
                      <span class="relative">Read more</span>
                    </a>
                  </div>

                </div>
              </div>
              <div
                data-te-modal-init
                class="fixed left-0 top-0 z-[1055] hidden h-full w-full overflow-x-auto overflow-y-hidden outline-none"
                id="exampleModalFullscreen"
                tabindex="-1"
                aria-labelledby="exampleModalFullscreenLabel"
                aria-hidden="true">
                <div
                  data-te-modal-dialog-ref
                  class="pointer-events-none relative w-auto translate-y-[-50px] opacity-0 transition-all duration-300 ease-in-out min-[0px]:m-0 min-[0px]:h-full min-[0px]:max-w-none">
                  <div
                    class="pointer-events-auto relative flex w-full flex-col rounded-md bg-white bg-clip-padding text-current shadow-lg outline-none dark:bg-neutral-600 min-[0px]:h-full min-[0px]:rounded-none min-[0px]:border-0">
                    <div
                      class="flex flex-shrink-0 items-center justify-between rounded-t-md border-b-2 border-neutral-100 border-opacity-100 p-4 dark:border-opacity-50 min-[0px]:rounded-none">

                      <h5
                        class="text-xl font-medium leading-normal text-neutral-800 dark:text-neutral-200"
                        id="exampleModalFullscreenLabel">
                        {item.Name}
                      </h5>

                      <button
                        type="button"
                        class="box-content rounded-none border-none hover:no-underline hover:opacity-75 focus:opacity-100 focus:shadow-none focus:outline-none"
                        data-te-modal-dismiss
                        aria-label="Close">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="h-6 w-6">
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </div>


                    <div class="relative p-4 min-[0px]:overflow-y-auto">
                      <p class="px-10 text-center leading-[3rem]">
                        Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                        Similique nesciunt repellat consectetur rem nam, facere,
                        expedita perspiciatis accusamus beatae aliquid dicta fugit ab
                        minima qui inventore. Animi tenetur tempore consequuntur!
                        Ducimus, praesentium, debitis iusto repellendus deleniti
                        molestias quod vero laboriosam deserunt itaque, voluptatum
                        labore nihil vitae repudiandae doloribus exercitationem at
                        aliquam! Nesciunt voluptatum temporibus excepturi dolores
                        incidunt laudantium odio debitis. Dicta totam sunt quo corrupti
                        accusamus et animi ratione consequatur molestias explicabo hic
                        eligendi necessitatibus laudantium, neque velit beatae magni.
                        Nemo vero blanditiis illum numquam libero necessitatibus fugiat
                        officiis repellendus. Optio, quis. Earum corporis vero debitis
                        unde rerum quod fuga, modi culpa veniam quos, quisquam soluta ea
                        voluptatum aliquam aperiam, vitae sint molestias? Cupiditate
                        quibusdam repudiandae, sapiente distinctio nihil sunt.
                        Aspernatur quas sapiente saepe quo autem ullam voluptatem
                        deleniti dolorum fugit tenetur incidunt obcaecati suscipit
                        adipisci in nulla quam ipsam enim facilis, corrupti alias rem?
                        Velit voluptatum recusandae officiis modi. Minus molestiae
                        consequatur assumenda reiciendis aperiam, eius iure repellendus.
                        Vel fugiat fuga quasi eos adipisci rem, necessitatibus odit
                        eius, quidem mollitia eum nesciunt officiis assumenda ab
                        laudantium reprehenderit quia! Consequuntur? Porro, nostrum et
                        dicta quo sint non sed officia voluptatem labore, laborum
                        dolores quos dolorem corporis iusto libero vel voluptate aliquid
                        obcaecati distinctio itaque optio, nihil magni temporibus.
                        Error, temporibus? Dolor, non? Adipisci nesciunt deleniti beatae
                        esse fugiat, quisquam minus eaque animi dolor aliquam aperiam.
                        Consequatur tempora amet fugit praesentium iste culpa quo,
                        quaerat perspiciatis deserunt quia nisi dolores ipsum? Nemo
                        incidunt quae nulla inventore aliquam alias natus iure!
                        Similique omnis enim esse praesentium est veniam dolor maxime.
                        Reprehenderit molestias cumque fugit dignissimos sunt sequi
                        enim. Adipisci beatae blanditiis dolores. Laudantium placeat,
                        asperiores tenetur praesentium beatae dignissimos magni
                        voluptate iusto dicta unde iste, ratione est sint eius fuga
                        consequatur eligendi iure provident. Consequuntur nobis quaerat
                        error est quos obcaecati exercitationem. Necessitatibus sunt
                        praesentium reiciendis tempora maiores? Asperiores similique,
                        natus sed quasi ut repudiandae aliquid deserunt tempore eligendi
                        repellat hic iusto eveniet neque quisquam, nulla porro, eum
                        magni repellendus minima eaque! Perspiciatis omnis odio
                        architecto recusandae quaerat harum vel ducimus ullam. Officiis
                        dolores sapiente nihil architecto veritatis quos provident
                        necessitatibus! Nostrum fugiat nisi placeat aspernatur deleniti
                        explicabo ab omnis odio. Ratione. Temporibus sunt nihil expedita
                        corrupti reiciendis, asperiores nostrum amet quam, totam ut
                        maiores magni saepe dolore at consectetur. Autem illum quos cum
                        perferendis quia voluptatibus tempore beatae quidem accusantium
                        temporibus. Magnam fugiat vero maiores, repellendus, ex quaerat
                        esse sunt eum itaque nihil pariatur laborum expedita veniam
                        dolorum reprehenderit nostrum accusantium autem! Consequatur
                        animi, quam numquam pariatur et quia odit ad. Porro provident
                        excepturi veniam exercitationem cumque deleniti aperiam!
                        Laudantium fugit magni, accusantium velit ipsa nostrum minima
                        temporibus distinctio cum minus quis voluptas expedita ad porro
                        quam earum fugiat, suscipit eius! Culpa vitae dolores labore
                        fugit necessitatibus similique ex ipsa? Dolorem earum quia
                        debitis quod suscipit aut nesciunt, necessitatibus error laborum
                        quasi nisi a cumque asperiores voluptate, expedita, officiis
                        perspiciatis ex! Ipsam optio quo deserunt magni cupiditate
                        exercitationem voluptas? Animi in asperiores quos minima a,
                        deleniti, facere vel ratione aut recusandae est voluptate minus.
                        Reiciendis eius doloremque magni, sit harum voluptatem?
                        Consectetur ad cum, rerum itaque veniam laudantium eligendi ut
                        tenetur mollitia nihil praesentium voluptatem, aspernatur,
                        dolorem modi?
                      </p>
                    </div>


                    <div
                      class="mt-auto flex flex-shrink-0 flex-wrap items-center justify-end rounded-b-md border-t-2 border-neutral-100 border-opacity-100 p-4 dark:border-opacity-50 min-[0px]:rounded-none">
                      <button
                        type="button"
                        class="inline-block rounded bg-primary-100 px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-primary-700 transition duration-150 ease-in-out hover:bg-primary-accent-100 focus:bg-primary-accent-100 focus:outline-none focus:ring-0 active:bg-primary-accent-200"
                        data-te-modal-dismiss>
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        })
      }


    </div>
  )
}

export default OtherCourses